var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("brokerage-tab-loader")
    : _c("div", { attrs: { id: "brokerage-settings-container" } }, [
        _c("div", { staticClass: "card" }, [
          _c("ul", { staticClass: "list-group list-group-flush" }, [
            _c("li", { staticClass: "list-group-item" }, [
              _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("global.doorr.settings")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "list-group-item" }, [
              _c(
                "div",
                { staticClass: "settings-container mx-0 col-lg-10" },
                [
                  _c(
                    "b-row",
                    { staticClass: "moregage-form" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  disabled:
                                    _vm.isEnabledForCurrentPlan(
                                      "brokerageSettings"
                                    ),
                                  placement: "top",
                                },
                                expression:
                                  "{\n                  disabled: isEnabledForCurrentPlan('brokerageSettings'),\n                  placement: 'top'\n                }",
                              },
                            ],
                            staticClass: "form-group-material-flex",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "material-input form-group-material w-auto",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-input material-input form app-form form-control form-control-filled domain-text",
                                    attrs: {
                                      id: "website-addon",
                                      disabled: "",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.domain))]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "title text-light-gray mb-2 mb-lg-0",
                                    attrs: { for: "subdomain-text" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "settings.brokerageTab.brokerageDomain"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("material-input", {
                              staticClass: "form-group-material-grow",
                              attrs: {
                                id: "subdomain-text",
                                disabled: !_vm.isEnabledForCurrentPlan(
                                  "brokerageCustomization"
                                ),
                                "aria-describedby": "website-addon",
                              },
                              model: {
                                value: _vm.localBrokerageData.subdomain,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localBrokerageData,
                                    "subdomain",
                                    $$v
                                  )
                                },
                                expression: "localBrokerageData.subdomain",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "my-auto pl-2" }, [
                              !_vm.linkCopied
                                ? _c(
                                    "span",
                                    { on: { click: _vm.copyLink } },
                                    [
                                      _c("icon", {
                                        attrs: {
                                          id: "copy-link",
                                          name: "clipboard",
                                          "icon-class":
                                            "clickable text-primary",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _c(
                                      "p",
                                      { staticClass: "bold text-primary" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "global.phrases.copiedToClipboard"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "moregage-form" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "form-group-material" },
                          [
                            _c("agents-select", {
                              ref: "agentsSelect",
                              attrs: {
                                multiple: false,
                                value:
                                  _vm.localBrokerageData.defaultBrokerageAgent,
                                "dropdown-parent":
                                  "#brokerage-settings-container",
                                "avatar-class": "col-xl-1",
                                "space-classes": "col-12 mt-0 pb-0 px-0",
                                label: _vm.$t(
                                  "settings.brokerageTab.defaultAgent"
                                ),
                              },
                              on: { change: _vm.handleChangeAgent },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "moregage-form align-items-center" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("material-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "settings.brokerageTab.brokerageLicenseId"
                              ),
                              label: _vm.$t(
                                "settings.brokerageTab.brokerageLicenseId"
                              ),
                            },
                            model: {
                              value: _vm.localBrokerageData.firmLicenseId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localBrokerageData,
                                  "firmLicenseId",
                                  $$v
                                )
                              },
                              expression: "localBrokerageData.firmLicenseId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.$t(
                                    "settings.brokerageTab.enterYourBrokerageLicenseNumber"
                                  ),
                                  placement: "top",
                                },
                                expression:
                                  "{\n                  title: $t(\n                    'settings.brokerageTab.enterYourBrokerageLicenseNumber'\n                  ),\n                  placement: 'top'\n                }",
                              },
                            ],
                            attrs: {
                              name: "info-circle",
                              "icon-class": "text-grey ml-1",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }